import React, { useCallback, useEffect, useRef, useState } from "react";
import Modal from "react-modal";
import { Button, Text } from "components";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import Select from "react-select";

function AddTaxInvoiceItemsForDeliveryChallan() {
  const [visible, setvisible] = useState(true);
  const [Item, setitem] = useState([]);
  const [editedQuantities, setEditedQuantities] = useState({});
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [salesOrderItemList, setSalesOrderItemList] = useState([]);
  const [groupID, setGroupID] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [customerItemGroups, setcustomerItemGroups] = useState([]);
  const [customerItemGpoupItems, setcustomerItemGpoupItems] = useState([]);
  const [editedPackaging, setEditedPackaging] = useState({});
  const { id } = useParams();
  let navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const location = useLocation();
  const delivery_challan_id = location.state?.delivery_challan_id;

  const searchParams = new URLSearchParams(location.search);
  const someKey = searchParams.get("someKey") === "true";
    console.log(id);
  const headers = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const [erplist, setErplist] = useState([]);
  useEffect(() => {
    // Retrieving data from sessionStorage
    const storedErplist = sessionStorage.getItem("erplist");

    if (storedErplist) {
      try {
        // Parsing the JSON string to an array of objects
        const parsedErplist = JSON.parse(storedErplist);
        setErplist(parsedErplist);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }
    }
  }, []);
  // console.log(erplist);
  const showActionColumn = erplist.some(
    (item) => item.erp_module_id == 30 && item.add
  );

  useEffect(() => {
    SalesOrderitemGetByID();
    // fetchData();
  }, []);

  const validationSchema = Yup.object().shape({});
  const formik = useFormik({
    initialValues: {
      quantity: "",
      sales_order_item_id: "",
      packaging: "",
      tax_invoice_id: id,
      // createdby: userId,
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleFormSubmit(values);
    },
  });

  const SalesOrderitemGetByID = () => {
    const obj = {
      delivery_challan_id: delivery_challan_id,
    };
    axios
      .post(
        "/api/purple-fusion/taxinvoiceitem/getitemdetaisdeliverychallan",
        obj,
        headers
      )
      .then((response) => {
        setSalesOrderItemList(response.data);
        setitem(response.data);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sobj = { id: delivery_challan_id };
  const fetchData = () => {
    axios
      .post("/api/purple-fusion/salesorder/get", sobj, headers)
      .then((response) => {
        console.log(response.data);
        axios
          .post(
            "/api/purple-fusion/customerGroupItems/get",
            { customer_id: response.data[0]?.customer_id },
            headers
          )
          .then((res) => {
            setcustomerItemGroups(res.data);
            console.log(res.data);
          })
          .catch((e) => {
            console.error("Error in featching data ", e);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleToggle = (itemId) => {
    setitem((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.id === itemId
          ? {
              ...item,
              checked: !item.checked,
            }
          : item
      );

      const allChecked = updatedItems.every((item) => item.checked);
      setSelectAllChecked(allChecked);
      return updatedItems;
    });
  };

  const handleSelectAll = () => {
    setitem((prevItems) => {
      const allChecked = !selectAllChecked;

      return prevItems.map((item) => {
        // Check if customerItemGpoupItems is empty or if the item passes the filter condition
        const passesFilter =
          customerItemGpoupItems.length === 0 ||
          customerItemGpoupItems.some(
            (item2) => item2.item_detail_id === item.item_detail_id
          );

        // Set 'checked' property based on whether the item passes the filter condition
        return { ...item, checked: passesFilter && allChecked };
      });
    });

    setSelectAllChecked(!selectAllChecked);
  };

  const handleQuantityChange = (itemId, value) => {
    setEditedQuantities((prevQuantities) => ({
      ...prevQuantities,
      [itemId]: value,
    }));
  };

  const handlePackagingChange = (itemId, value) => {
    setEditedPackaging((prevRemarks) => ({
      ...prevRemarks,
      [itemId]: value,
    }));
  };
  // console.log(editedQuantities);
  const handleFormSubmit = (values) => {
    // console.log(Item.filter(item=>item.checked==true))
    console.log(Item);
    const newArray = Item.filter((item) => item.checked == true).map(
      (item) => ({
        quantity:
          editedQuantities[item.id] !== undefined
            ? editedQuantities[item.id]
            : " ",
        packaging:
          item.checked && editedPackaging[item.id] === undefined
            ? item.quantity_entry // Set the default value here
            : editedPackaging[item.id] !== undefined
            ? editedPackaging[item.id]
            : "",
            delivery_challan_item_id: item.salesorderitemid,

        tax_invoice_id: id,
        // createdby: userId,
      })
    );
    console.log(newArray);
    if (newArray.length > 0) {
      axios
        .post("/api/purple-fusion/taxinvoiceitem/deliverychallan/create", newArray, headers)
        .then((response) => {
          console.log(response.data);
          const message = response.data.message;
          response.data.status
            ? toast.success(message, {
                autoClose: 2000,
                onClose: () => {
                  setvisible(false);
                  // navigate(`/taxinvoiceitem/list/${id}`);
                  navigate(`/taxinvoiceitem/list/${id}`, {
                     state: { delivery_challan_id: delivery_challan_id },
                  });
                },
              })
            : toast.error(message, {
                autoClose: 2000,
                onClose: () => {
                  // setvisible(false);
                  navigate(`/taxinvoiceitem/list/${id}`, {
                    state: { delivery_challan_id: delivery_challan_id },
                  });
                },
              });
        })
        .catch((error) => {
          console.log(error);
          setvisible(false);
          // navigate(`/taxinvoiceitem/list/${id}`);
          navigate(`/taxinvoiceitem/list/${id}`, {
            state: { delivery_challan_id: delivery_challan_id },
          });
        });
    } else {
      toast.error("Please Select the Item First ");
    }
  };

  const fetchGroupItems = (id) => {
    const obj = { customer_item_group_id: id };
    console.log(id);
    axios
      .post("/api/purple-fusion/customerItemGroupItem/get", obj, headers)
      .then((res) => {
        setcustomerItemGpoupItems(res.data);
        console.log(res.data);
      })
      .catch((e) => {
        console.error("Error in featching data ", e);
      });
  };

  const customStyles = {
    content: {
      width: "90%",
      height: "90%",
      margin: "auto",
    },
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      // zIndex: 999,
    },
  };

  return (
    <div>
      {showActionColumn ? (
        <div>
          <Modal
            isOpen={visible}
            style={customStyles}
            // className="w-[80%] md:w-[80%] m-auto border-2 mt-20 rounded-xl p-6 "
            onRequestClose={() => {}}
          >
            <form onSubmit={formik.handleSubmit}>
              <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
                <div className="flex md:flex-col flex-row md:gap-5 items-start justify-evenly w-full">
                  <div className="flex flex-1 flex-col gap-[19px] justify-start md:px-5 w-full">
                    <div>
                      <div className="flex flex-row items-center justify-start ">
                        <div className="flex flex-row  items-start justify-between w-full ">
                          <Text
                            className="mt-[5px] md:text-xl sm:text-[24px] text-base text-black-900 tracking-[0.20px]"
                            size="txtInterMedium24"
                          >
                            {someKey
                              ? "Tax Invoice > Tax Invoice Item"
                              : "Add Tax Invoice Items"}
                          </Text>
                        </div>
                        <div className="flex flex-row items-center justify-end ml-auto top-2 ">
                          <Button
                            className="cursor-pointer font-medium mb-1.5 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]  active:scale-90 transition-transform duration-200"
                            shape="round"
                            color="blue_A700"
                            size="base"
                            variant="fill"
                            type="submit"
                          >
                            Save
                          </Button>
                          <Button
                            className="cursor-pointer font-medium mb-3 min-w-[70px] rounded-[7px] text-center text-xl tracking-[0.20px]"
                            shape="round"
                            color="white"
                            size="base"
                            variant="fill"
                            type="button"
                            onClick={() => {
                              setvisible(false);
                              navigate(`/taxinvoiceitem/list/${id}`, {
                                state: { delivery_challan_id: delivery_challan_id },
                              });
                            }}
                          >
                            ╳
                          </Button>
                        </div>
                      </div>
                      <ToastContainer />
                      <div className="flex flex-col items-center justify-start mt-4 w-full">
                        <div className="md:gap-5 gap-[30px] grid md:grid-cols-1 grid-cols-1 justify-center min-h-[auto] w-full">
                          <div className="grid grid-cols-2 z-1000 relative">
                            <div className="w-full">
                              <input
                                type="text"
                                placeholder="Search..."
                                className="bg-white-A700 border border-gray-400_02 border-solid  h-[40px] rounded-[5px] mb-0 w-[80%]"
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                              />
                            </div>
                            {/* <div className="h-auto z-1100 flex flex-row items-center justify-start">
                              <span>Filter By Groups: &nbsp;</span>
                              <div>
                                <Select
                                  options={[
                                    { label: "All", value: null },
                                    ...customerItemGroups.map((resstate) => ({
                                      label: resstate.name,
                                      value: resstate.id,
                                    })),
                                  ]}
                                  className="bg-white-A700 border w-60 border-gray-200_02 border-solid h-[40px] z-1000 rounded-[10px]"
                                  onChange={(selectedOption) => {
                                    if (selectedOption.value == null) {
                                      setcustomerItemGpoupItems([]);
                                    } else {
                                      fetchGroupItems(selectedOption.value);
                                    }
                                  }}
                                  placeholder="All"
                                />
                              </div>
                            </div> */}
                          </div>

                          <div className="flex flex-1 relative flex-col max-h-[400px] h-auto gap-[16px] items-start justify-start w-full overflow-auto border-2">
                            <table className="w-full font-inter  text-gray-800 text-sm text-left overflow-scroll dark:text-gray-400">
                              <thead className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky top-0">
                                <tr>
                                  <th className="px-2 py-3">
                                    <label>
                                      <input
                                        className="rounded-[5px]"
                                        type="checkbox"
                                        onClick={handleSelectAll}
                                        checked={selectAllChecked}
                                      />
                                      {"   "} All
                                    </label>
                                  </th>
                                  {/* <th>ID</th> */}
                                  {/* <th className="px-6 py-3">Sales Order Code</th> */}
                                  <th className="px-2 py-3">Item Name</th>
                                  <th className="px-2 py-3">Quantity</th>
                                  <th className="px-2 py-3">Packaging</th>
                                  <th className="px-2 py-3">Code</th>
                                  <th className="px-2 py-3">Provided Code</th>
                                  <th className="px-2 py-3">
                                    Item Descripsion
                                  </th>
                                  <th className="px-2 py-3">HSN Code</th>
                                  <th className="px-2 py-3">SAC Code</th>
                                  <th className="px-2 py-3">Inital Quantity</th>
                                  <th className="px-2 py-3">
                                    Remaining Quantity
                                  </th>
                                  <th className="px-2 py-3">
                                    Available Quantity
                                  </th>
                                  <th className="px-2 py-3">Cost Price</th>
                                  <th className="px-2 py-3">Item Amount</th>
                                  <th className="px-2 py-3">SGST %</th>
                                  <th className="px-2 py-3">CSGT %</th>
                                  <th className="px-2 py-3">IGST %</th>
                                  <th className="px-2 py-3">SGST Amount</th>
                                  <th className="px-2 py-3">CGST Amount</th>
                                  <th className="px-2 py-3">IGST Amount</th>
                                  <th className="px-2 py-3">Total Tax</th>
                                  <th className="px-2 py-3">Total Amount</th>
                                </tr>
                              </thead>
                              <tbody className="text-gray-800 border-2">
                                {Item.filter((item1) => {
                                  if (customerItemGpoupItems.length == 0) {
                                    return true;
                                  } else {
                                    return customerItemGpoupItems.some(
                                      (item2) =>
                                        item2.item_detail_id ===
                                        item1.item_detail_id
                                    );
                                  }
                                })
                                  .filter(
                                    (item) =>
                                      (item.initialquantity -
                                        item.quantityforinvoicecreateditems >
                                        0 &&
                                        item.item_name
                                          .toLowerCase()
                                          .includes(
                                            searchTerm.toLowerCase()
                                          )) ||
                                      item.item_code_op
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase()) ||
                                      item.item_code
                                        .toLowerCase()
                                        .includes(searchTerm.toLowerCase())
                                  )
                                  .map((item) => (
                                    <tr key={item.id} className="border-2">
                                      <td className="px-2 py-3">
                                        <input
                                          className="rounded-[5px]"
                                          type="checkbox"
                                          id={`item-${item.id}`}
                                          checked={item.checked}
                                          onChange={() => handleToggle(item.id)}
                                        />
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.item_name}
                                      </td>
                                      <td className="px-2 py-3 grid grid-cols-1">
                                        <input
                                          className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                                          type="number"
                                          value={
                                            editedQuantities[item.id] !==
                                            undefined
                                              ? editedQuantities[item.id]
                                              : " "
                                          }
                                          disabled={!item.checked}
                                          onChange={(e) =>
                                            handleQuantityChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          max={
                                            item.initialquantity -
                                            item.quantityforinvoicecreateditems
                                          }
                                          min={1}
                                          required={item.checked}
                                          step="0.0001"
                                        />
                                        {editedQuantities[item.id] &&
                                          ((editedQuantities[item.id] >
                                            (item.initialquantity -
                                              item.quantityforinvoicecreateditems <
                                            1
                                              ? 0
                                              : item.initialquantity -
                                                item.quantityforinvoicecreateditems) && (
                                            <span className="text-red-500 text-xs">
                                              Exceed remaining quantity
                                            </span>
                                          )) ||
                                            (editedQuantities[item.id] >
                                              item.available_quantity && (
                                              <span className="text-red-500 text-xs">
                                                Exceed available quantity
                                              </span>
                                            )))}
                                      </td>
                                      <td>
                                        <input
                                          className="bg-white-A700 border border-gray-400_02 border-solid h-[40px] rounded-[10px] w-full"
                                          type="text"
                                          value={
                                            editedPackaging[item.id] !==
                                            undefined
                                              ? editedPackaging[item.id]
                                              : " "
                                          }
                                          disabled={!item.checked}
                                          onChange={(e) =>
                                            handlePackagingChange(
                                              item.id,
                                              e.target.value
                                            )
                                          }
                                          required={item.checked}
                                        />
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.item_code}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.item_code_op}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.item_description}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.hsn_code ? item.hsn_code : 0}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.sac_code ? item.sac_code : 0}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.initialquantity}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.initialquantity -
                                          item.quantityforinvoicecreateditems}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.available_quantity}
                                      </td>

                                      <td className="px-2 py-3">
                                        {item.cost_price}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          item.cost_price *
                                            editedQuantities[item.id]
                                        )
                                          ? 0
                                          : item.cost_price *
                                            editedQuantities[item.id]}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.sgst_percentage}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.cgst_percentage}
                                      </td>
                                      <td className="px-2 py-3">
                                        {item.igst_percentage}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          (item.cost_price *
                                            editedQuantities[item.id] *
                                            item.sgst_percentage) /
                                            100
                                        )
                                          ? 0
                                          : (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                            100}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          (item.cost_price *
                                            editedQuantities[item.id] *
                                            item.cgst_percentage) /
                                            100
                                        )
                                          ? 0
                                          : (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                            100}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          (item.cost_price *
                                            editedQuantities[item.id] *
                                            item.igst_percentage) /
                                            100
                                        )
                                          ? 0
                                          : (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                            100}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          (item.cost_price *
                                            editedQuantities[item.id] *
                                            item.sgst_percentage) /
                                            100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                              100
                                        )
                                          ? 0
                                          : (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                              100}
                                      </td>
                                      <td className="px-2 py-3">
                                        {Number.isNaN(
                                          (item.cost_price *
                                            editedQuantities[item.id] *
                                            item.sgst_percentage) /
                                            100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                              100 +
                                            editedQuantities[item.id] *
                                              item.cost_price
                                        )
                                          ? 0
                                          : (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                              100 +
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                              100 +
                                            editedQuantities[item.id] *
                                              item.cost_price}
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                              <tfoot className="text-sm w-full border-2 text-gray-800 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 sticky bottom-0 ">
                                <tr className="text-sm bg-gray-200">
                                  <td colSpan="7"> </td>
                                  <td className="px-4 py-1">
                                    <span className="text-black font-bold">
                                      TOTAL
                                    </span>
                                  </td>
                                  <td colSpan="4"> </td>
                                  <td className="px-4 py-1">
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          item.cost_price *
                                            (editedQuantities[item.id] || 0),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td colSpan="3"> </td>
                                  <td className="px-4 py-1">
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          (Number.isNaN(
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                              100
                                          )
                                            ? 0
                                            : (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.sgst_percentage) /
                                              100),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td className="px-4 py-1">
                                    {/* Sum of Total Amount */}
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          (Number.isNaN(
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.cgst_percentage) /
                                              100
                                          )
                                            ? 0
                                            : (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.cgst_percentage) /
                                              100),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td className="px-4 py-1">
                                    {/* Sum of Total Amount */}
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          (Number.isNaN(
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.igst_percentage) /
                                              100
                                          )
                                            ? 0
                                            : (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.igst_percentage) /
                                              100),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td className="px-4 py-1">
                                    {/* Sum of Total Amount */}
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          (Number.isNaN(
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                              100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.cgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.igst_percentage) /
                                                100
                                          )
                                            ? 0
                                            : (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.sgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.cgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.igst_percentage) /
                                                100),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                  <td className="px-4 py-1">
                                    {/* Sum of Total Amount */}
                                    {Item.filter((item) => item.checked)
                                      .reduce(
                                        (acc, item) =>
                                          acc +
                                          (Number.isNaN(
                                            (item.cost_price *
                                              editedQuantities[item.id] *
                                              item.sgst_percentage) /
                                              100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.cgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.igst_percentage) /
                                                100 +
                                              editedQuantities[item.id] *
                                                item.cost_price
                                          )
                                            ? 0
                                            : (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.sgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.cgst_percentage) /
                                                100 +
                                              (item.cost_price *
                                                editedQuantities[item.id] *
                                                item.igst_percentage) /
                                                100 +
                                              editedQuantities[item.id] *
                                                item.cost_price),
                                        0
                                      )
                                      .toFixed(2)}
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </Modal>
        </div>
      ) : (
        <div className="flex justify-center items-center h-screen">
          <div className="text-4xl text-red-500">No Access</div>
        </div>
      )}
    </div>
  );
}

export default AddTaxInvoiceItemsForDeliveryChallan;
